type BudgetComponentType = string | null | undefined;

type ShouldTreatSuggestedAsCompositionOriginalParams = {
  type: BudgetComponentType;
  total?: number | null;
};

export const shouldTreatSuggestedAsCompositionOriginal = ({
  type,
  total,
}: ShouldTreatSuggestedAsCompositionOriginalParams): boolean => {
  if (type === 'composition_original') {
    return true;
  }

  if (type !== 'suggested_composition') {
    return false;
  }

  return Number(total || 0) > 0;
};
